"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactHelmet = require("react-helmet");
var HtmlHeader = function HtmlHeader(_ref) {
  var title = _ref.title,
    description = _ref.description,
    image = _ref.image,
    favicon = _ref.favicon;
  return title ? /*#__PURE__*/_react["default"].createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react["default"].createElement("title", null, title), /*#__PURE__*/_react["default"].createElement("meta", {
    property: "og:title",
    content: title
  }), favicon && /*#__PURE__*/_react["default"].createElement("link", {
    rel: "shortcut icon",
    href: favicon
  }), description && /*#__PURE__*/_react["default"].createElement("meta", {
    name: "description",
    content: description
  }), description && /*#__PURE__*/_react["default"].createElement("meta", {
    property: "og:description",
    content: description
  }), image && /*#__PURE__*/_react["default"].createElement("meta", {
    property: "og:image",
    content: "".concat(image, "?format=jpeg")
  })) : /*#__PURE__*/_react["default"].createElement("div", null);
};
HtmlHeader.propTypes = {
  title: _propTypes["default"].string.isRequired,
  description: _propTypes["default"].string,
  favicon: _propTypes["default"].string,
  image: _propTypes["default"].string
};
var _default = exports["default"] = HtmlHeader;